/**
 * Per-panel KLine chart instance registry for DSL / agent snapshot reads.
 */

import type { KLineData } from "klinecharts";
import type { ChartPanelId } from "@/vybe-trader-client/chart/stores/chartPanelTypes";

export interface ChartVisibleRange {
  from: number;
  to: number;
  realFrom: number;
  realTo: number;
}

/** Minimal chart API surface used by Chart.Visible.Get collector. */
export interface RegisteredChartPanel {
  getDataList: () => KLineData[];
  getVisibleRange: () => ChartVisibleRange;
  getIndicatorByPaneId?: () => unknown;
  getOverlaysByPaneId?: () => unknown;
}

const panels = new Map<ChartPanelId, RegisteredChartPanel>();

export function registerChartPanel(
  panelId: ChartPanelId,
  chart: RegisteredChartPanel,
): void {
  panels.set(panelId, chart);
}

export function unregisterChartPanel(panelId: ChartPanelId): void {
  panels.delete(panelId);
}

export function getChartPanel(
  panelId: ChartPanelId,
): RegisteredChartPanel | undefined {
  return panels.get(panelId);
}

/** @internal test helper */
export function clearChartPanelRegistry(): void {
  panels.clear();
}
